import api from '../../../App/socket';

export const deleteLeadRequest = leadId => api.send({
    api: 'module',
    module: 'Leads',
    classMethod: 'DeleteLead',
    options:
            {
                where:
                    {
                        _id: leadId,
                    },
            },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/requests/delete_lead_request.js